import { TotalCropReportTable, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';

export default class ComponentToPrint extends React.Component {
    render() {

        const reportData = this.props.reportData;
        const columeNames = this.props.columeNames;
        const searchData = this.props.selectedSearchValues;
        const allTotal = this.props.allTotal;
        const total = this.props.total

        return (
            <div>
                <h3><center><u>Daily Harvester Performances Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.collectionID}</div>
                    <div className="col"><b>Gang: </b> {searchData.gang}</div>
                    <div className="col"><b>Month: </b> {searchData.month}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>Name</TableCell>
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>EPF</TableCell>
                                    {columeNames.map((item) => (
                                        <TableCell style={{
                                            fontWeight: "bold", backgroundColor: item.columnColor == 0 ? null :
                                                item.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                        }} align='center'>{item.columnName}</TableCell>
                                    ))}
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>Total Kg</TableCell>
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>Total Days</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.map((row) => (
                                    <TableRow key={row.employeeID}>
                                        <TableCell align='left'>{row.firstName}</TableCell>
                                        <TableCell align='center'>{row.epfNo}</TableCell>
                                        {columeNames.map((column) => {
                                            const value = row[column.column];
                                            return (
                                                <TableCell style={{
                                                    backgroundColor: column.columnColor == 0 ? null :
                                                        column.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                                }} align='center'>
                                                    {value == undefined ? '-' :
                                                        row.employeeTypeID == 1 ?
                                                            ((row.configurationValue > parseInt(value)) ?
                                                                <Chip label={parseInt(value)} style={{ border: '2px solid' }} color="primary" variant="outlined" /> :
                                                                parseInt(value)) :
                                                            <Chip label={parseInt(value)} style={{ border: '2px solid' }} color="secondary" variant="outlined" />
                                                    }</TableCell>
                                            );
                                        })}
                                        <TableCell style={{ fontWeight: "bold" }} align='center'>{row.total}</TableCell>
                                        <TableCell style={{ fontWeight: "bold" }} align='center'>{row.totalDays}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell align='center' style={{ fontWeight: "bold" }} colSpan={2}>Plucker Count</TableCell>
                                    {columeNames.map((column) => {
                                        const value = reportData.filter(x => x[column.column])
                                        return (
                                            <TableCell style={{
                                                fontWeight: "bold", backgroundColor: column.columnColor == 0 ? null :
                                                    column.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                            }} align='center'>{value.length == 0 ? '-' :
                                                parseInt(value.length)}</TableCell>
                                        );
                                    })}
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>-</TableCell>
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>-</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align='center' style={{ fontWeight: "bold" }} colSpan={2}>Total Kg</TableCell>
                                    {columeNames.map((column) => {
                                        const value = allTotal.find(x => x.name == column.column)
                                        return (
                                            <TableCell style={{
                                                fontWeight: "bold", backgroundColor: column.columnColor == 0 ? null :
                                                    column.columnColor == 1 ? '#6aa3d6' : '#E25c5a'
                                            }} align='center'>{value == undefined ? '-' :
                                                parseInt(value.value)}</TableCell>
                                        );
                                    })}
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>{parseInt(total)}</TableCell>
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>-</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        );
    }
}